module.exports = __webpack_public_path__ + "static/media/ic_player_volume_off.01ab00c6.svg";